<template>
  <!-- Use fluid to make the dialog adapt to screen size, remove persistent if you want user to click outside to close -->
  <v-dialog
    v-model="isVisible"
    persistent
    :max-width="dialogWidth"
    :fullscreen="isMobile" 
  >
    <v-card>
      <!-- Card Actions (Close Button) -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn icon color="red darken-1" @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>

      <!-- Title & Subtitle -->
      <v-card-title class="headline wrap-title prompt-text" >
        {{ modelData.name }}
      </v-card-title>
      <v-card-subtitle class="wrap-subtitle">{{ modelData.subtitle }}</v-card-subtitle>

      <!-- Card Text -->
      <v-card-text>

        <!-- Responsive Embed Container -->
        <div class="responsive-embed" v-if="type === 0">
          <!-- If you prefer <iframe>, you can switch to that. <embed> should also work. -->
          <embed 
            :src="'https://sketchfab.com/models/' + modelData.id + '/embed'"
            allowfullscreen
          />
          
        </div>
        <img v-else
            :src="'assets/'+ getType()+ '/output/' + modelData.id + '.png'"
            class="thumbnail-img"
          />
          
        <!-- Detail Levels (use flex-wrap) -->
        <div class="detail-levels mt-3">
          <v-btn
            v-for="level in orderedLevels"
            :key="level"
            small
            class="ma-1"
            :color="level === selectedLevel ? 'primary' : 'grey lighten-1'"
            @click="selectLevel(level)"
          >
            {{ levelMap[level] }}
          </v-btn>
        </div>

        <!-- Prompt Text -->
        <!-- <div class="prompt-text mt-3">
          <p class="prompt-content">
            {{ promptTexts[levelToIndex[selectedLevel]] }}
          </p>
        </div> -->
        <div class="prompt-text mt-3">
          <p
            class="prompt-content"
            :class="`prompt-content-level${selectedLevel}`"
          >
            {{ promptTexts[levelToIndex[selectedLevel]] }}
          </p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModelPopup",
  props: {
    type: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    modelData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Tracks the dialog's visibility
      isVisible: this.visible,

      // Order in which buttons appear
      orderedLevels: [4, 5, 3, 2, 1],

      // Which level is currently selected
      selectedLevel: 4,

      // Maps each level to its displayed name
      levelMap: {
        4: "Summary",
        5: "Keywords",
        3: "Functional Semantic",
        2: "Moderately Descriptive",
        1: "Comprehensive Description",
      },

      // Maps the selected level to promptTexts index
      levelToIndex: {
        1: 0,
        2: 1,
        3: 2,
        4: 3,
        5: 4,
      },

      // This will be updated in initializeSketchfabViewer
      promptTexts: [],
    };
  },
  computed: {
    // A quick mobile check, could also use Vuetify’s $vuetify.breakpoint
    isMobile() {
      return window.innerWidth < 600;
    },
    // If on mobile, we let the dialog stretch to the screen size.
    // Otherwise, we limit it to 900px or whatever suits you.
    dialogWidth() {
      return this.isMobile ? "100%" : 700;
    },
  },
  watch: {
    visible(val) {
      this.isVisible = val;
      if (val) {
        this.initializeSketchfabViewer();
      }
    },
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
    selectLevel(level) {
      this.selectedLevel = level;
    },
    getType() {
      if (this.type === 0) {
        return "Objverse";
      } else if (this.type === 1) {
        return "shapenet";
      }else if (this.type === 2) {
        return "PIX";
      }else if (this.type === 3) {
        return "Omni";
      }else if (this.type === 4) {
        return "Toys";
      }else if (this.type === 5) {
        return "GSO2";
      }else if (this.type === 6) {
        return "ABO";
      }
    },  
    initializeSketchfabViewer() {
      if (!this.modelData.id) return;
      console.log("Initializing Sketchfab viewer for model", this.modelData);

      // Prompt text array in [level1, level2, level3, level4, level5] order
      this.promptTexts = [
        this.modelData["level1"],
        this.modelData["level2"],
        this.modelData["level3"],
        this.modelData["level4"],
        this.modelData["level5"],
      ];
    },
  },
  mounted() {
    // Re-initialize if loaded while visible
    if (this.visible) {
      this.initializeSketchfabViewer();
    }
    // Optional: add a resize listener to recalc isMobile if you want it dynamic
    window.addEventListener('resize', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.$forceUpdate();
    });
  },
};
</script>

<style scoped>
/* Ensure very long titles wrap instead of pushing content off screen */
.wrap-title {
  white-space: normal;
  word-break: break-word;
}
.wrap-subtitle {
  white-space: normal;
  word-break: break-word;
  text-align: center;
  font-size: 16px;
  color: #777;
  margin-top: -10px;
  margin-bottom: 10px;
}

/* Make the embed container maintain aspect ratio (16:9) and scale on small screens */
.responsive-embed {
  position: relative;
  padding-top: 56.25%; /* 16:9 ratio; adjust if you want a different ratio */
  overflow: hidden;
  width: 100%;
  max-height: 80vh; /* prevents the embed from being too tall on narrow screens */
}

.responsive-embed embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.thumbnail-img {
  width: 100%;
  height: 30vh;
  object-fit:fill;
}

/* Make detail-level buttons wrap to multiple rows on small screens */
.detail-levels {
  display: flex;
  flex-wrap: wrap;       /* allow buttons to wrap */
  justify-content: center; 
}

/* Prompt text styling */
.prompt-text {
  text-align: center;
  font-size: 14px;
  color: #555;
}



/* Shared styles for prompt-content */
.prompt-content {
  font-family: 'Georgia', 'Times New Roman', serif; /* Elegant and readable font families */
  font-size: 1.2rem; /* Adjust as needed */
  font-weight: 400; /* Normal font weight for readability */
  font-style: italic; /* Italicizes the text */
  margin: 0;
  text-align: justify; /* Align text to both left and right margins */
  line-height: 1.6; /* Adjust line spacing for readability */
  padding: 15px; /* Add padding to space the text from the edges */
  border-radius: 10px; /* Make the background edges rounded */
  color: #030303; /* Ensure text stands out against the gradient background */
}

/* Colors for each level */
/* Level 1 */
.prompt-content-level1 {
  background: linear-gradient(135deg, rgba(163, 6, 6, 0.1), rgba(250, 77, 9, 0.1)); /* Coral and Light Salmon */
  box-shadow: 0 4px 8px rgba(255, 127, 80, 0.1); /* Soft coral glow */
}

/* Level 2 */
.prompt-content-level2 {
  background: linear-gradient(135deg, rgba(3, 112, 17, 0.1), rgba(33, 247, 33, 0.1)); /* Light Sea Green and Pale Turquoise */
  box-shadow: 0 4px 8px rgba(32, 178, 170, 0.4); /* Soft teal glow */
}

/* Level 3 */
.prompt-content-level3 {
  background: linear-gradient(135deg, rgba(25, 5, 139, 0.1), rgba(64, 67, 241, 0.1)); /* Medium Slate Blue and Thistle */
  box-shadow: 0 4px 8px rgba(123, 104, 238, 0.4); /* Soft purple glow */
}

/* Level 4 */
.prompt-content-level4 {
  background: linear-gradient(135deg, rgba(247, 63, 90, 0.1), rgba(255, 129, 115, 0.1)); /* Light Pink and Misty Rose */
  box-shadow: 0 4px 8px rgba(255, 182, 193, 0.4); /* Soft pink glow */
}

/* Level 5 */
.prompt-content-level5 {
  background: linear-gradient(135deg, rgba(18, 142, 184, 0.1), rgba(45, 153, 248, 0.1)); /* Light Blue and Alice Blue */
  box-shadow: 0 4px 8px rgba(173, 216, 230, 0.4); /* Soft blue glow */
}



</style>
